// extracted by mini-css-extract-plugin
export var component = "contact-module--component--3ir5U";
export var icon = "contact-module--icon--3RNyj";